import React, { FC } from "react";

/**
 * Note: this renders the inline message text inside its parent wrapper
 * (BetaPlanDaysRemainNotSubscribedPlanBanner), which already applies the
 * font-size and weight via `.ni-dash-empty-message`.
 */
const BetaPlanExpiredMsgComponent: FC<{ daysRemaining: number }> = ({
  daysRemaining,
}) => {
  if (daysRemaining < 0) {
    return (
      <>
        Your beta plan has <strong>expired</strong>.
        <br />
        Upgrade now to avoid losing access.
      </>
    );
  }

  return (
    <>
      Your beta plan{" "}
      {daysRemaining <= 0 ? (
        <>
          is expiring <strong>today</strong>.
        </>
      ) : (
        <>
          ends in <strong>{daysRemaining} days</strong>.
        </>
      )}
      <br />
      Upgrade now to avoid losing access.
    </>
  );
};

export default BetaPlanExpiredMsgComponent;
